import dynamic from "next/dynamic";
import { renderLineBreaks } from "../../../utils";
import {
  PriceItemWrapper,
  ItemDescriptionContainer,
  Title,
  ItemPriceContainer,
  Price,
  PriceDescription,
} from "./styles";

const Link = dynamic(() => import("../link/link"));
const ListItem = dynamic(() => import("../list-item/list-item"));

export const PriceItem = ({
  title,
  itemList,
  price,
  priceDescription,
  button,
}) => {
  return (
    <PriceItemWrapper>
      <ItemDescriptionContainer>
        {title && <Title>{renderLineBreaks(title)}</Title>}
        <ul>
          {itemList &&
            itemList.map((item, index) =>
              index === 0 ? (
                <ListItem key={item.id} {...item} isFirst />
              ) : (
                <ListItem key={item.id} {...item} />
              )
            )}
        </ul>
      </ItemDescriptionContainer>
      <ItemPriceContainer>
        <div>
          {price && <Price>{renderLineBreaks(price)}</Price>}
          {priceDescription && (
            <PriceDescription>
              {renderLineBreaks(priceDescription)}
            </PriceDescription>
          )}
        </div>
        {button && <Link type="buttonPrimary" {...button} />}
      </ItemPriceContainer>
    </PriceItemWrapper>
  );
};

export default PriceItem;
